import React from "react";
import styled from "styled-components";
import {borderColour, headerBackgroundColour} from "../../../style/styleConsts";
import Warnings from "./warnings/Warnings";
import logo from "../../../../images/tim-logo-login.png";
import {Link} from "react-router-dom";
import Search from "./search/Search";
import CreateIdeaModalButton from "../../contribute/createIdea/CreateIdeaModalButton";
import Settings from "./settings/Settings";
import {BackToOldTIMButton} from "./backToOldTIM/BackToOldTIMButton";
import HelpButton from "./help/HelpButton";

const AppHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
`;

const Header = styled.div`
    min-width: 600px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${headerBackgroundColour};
    border-bottom: 1px solid ${borderColour};
    padding-top: 13px;
    padding-right: 18px;
    padding-left: 20px;
    padding-bottom: 13px;
`;

const Controls = styled.div`
    display: flex;
    align-items: center;
`;

const SearchContainer = styled.div`
    margin-right: 7px;
`;

const LogoContainer = styled(Link)`
    display: flex;
    align-items: center;
    margin-right: 10px;
`;

const LogoImg = styled.img`
    width: 139px;
    height: 50px;
    vertical-align: middle;
    margin-right: 30px;
`;

const ButtonSpacer = styled.div`
    width: 8px;
`;

export const AppHeader = ({}) => {
    return <AppHeaderContainer className="t-app-header">
        <Warnings/>
        <Header>
            <LogoContainer to="/">
                <LogoImg src={logo}/>
            </LogoContainer>
            <Controls>
                <CreateIdeaModalButton/>
                <SearchContainer>
                    <Search/>
                </SearchContainer>
                <BackToOldTIMButton/>
                <ButtonSpacer/>
                <HelpButton/>
                <Settings/>
            </Controls>
        </Header>
    </AppHeaderContainer>
};

export default AppHeader;
